import { motion } from 'framer-motion';
import * as React from 'react';
import { useContext } from 'react';
import { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SettingsContext } from '../../Context';
import { Database } from '../../Managers/DataManager';
import { SettingsData } from '../../Managers/Settings';
import { VideoModel } from '../../Models/Video.interface';
import { VideoButtonGroup } from '../Buttons/VideoButtonGroup';
import "./Featured.css";


type FeaturedProps = {

}

export const Featured = (props: FeaturedProps) => {


    const [video, setVideo] = useState<VideoModel>()
    // const id = 10175
    // const uuid = "e4599b95-9827-4c64-87ee-13c92930b64c"
    const leaving = new Subject()


    const { language, locale} = useContext<SettingsData>(SettingsContext)


    useEffect(() => {
        if(!language){
            return
        }
        Database.get(`/featured/${language}`)
        .then(sub => {
            sub.pipe(takeUntil(leaving))
            .subscribe(setVideo)
        })
        .catch(console.error)
    }, [language])

    return(
        <motion.div className="featured-outer-container">
            <div className="featured-container">
                <motion.img 
                    src={video?.thumbnail}
                    alt="Featured Image"
                />
                <div className="featured-info">
                    <h4>{locale.featuredHeader}</h4>
                    <h2>{video?.name}</h2>
                    <p>{video?.long_text}</p>
                    <VideoButtonGroup 
                        video={video}
                    />

                </div>

            </div>

        </motion.div>
    )
}